import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import { AdsGETApiAuth } from "../../../Constant/api";
import { slugs } from "../../../Constant/slugs";
const columns = [
  {
    id: 1,
    name: "id",
    selector: (row) => row.id,
    sortable: true,
    reorder: true,
  },
  {
    id: 31,
    name: "Title",
    selector: (row) => row.title.rendered,
    sortable: true,
    reorder: true
  },
  {
    id: 312,
    name: "Date",
    selector: (row) => row.meta.book_author,
    sortable: true,
    reorder: true
  },
  {
    id: 3,
    name: "View",
    right: true,
    cell: (row) => <Link to={`${slugs.books_details}${row.slug}`}>View</Link>,

  }
];

export default function AllBooks() {
  const [Projects1, setProjects1] = React.useState([])
  const [CustomersList, setCustomersList] = React.useState([])
  const [Reload, setReload] = React.useState(false)
  const GetAllProjects = (params) => {
    setReload(true)
    setProjects1([])
    AdsGETApiAuth(params, slugs.db_slug_book)
      .then((res) => {
        setProjects1(res.data)
        setCustomersList(res.data.filter(a => a.meta.book_author == "2024"))
        console.log("done")
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
        setReload(false)
      })
  }
  useEffect(() => {
    GetAllProjects({
      per_page: 100,
      _fields: "id,title,slug,meta"
    })

  }, [])

  return (
    <div>
      <div className="row" style={{ padding: "30px 30px" }}>
        <div className="col-md-8 button">
          <h2>All Books</h2>
        </div>
        <div className="col-md-4" style={{ textAlign: 'right' }}>
          <a href="/">Dashboard</a> / All Books
        </div>
      </div>
      <a href={slugs.new_book}>
        <div className="sign-in-button-4" style={{ width: "150px", margin: "10px" }}
          onClick={() => {

          }}
        >Add New Book</div>
      </a>
      <div style={{ display: "inline" }}>
        <div style={{ display: "inline-block" }}>
          <div className="sign-in-button-4" style={{ width: "150px", margin: "10px" }}
            onClick={() => {
              setCustomersList(Projects1.filter(a => a.meta.book_author == "2024"))

            }}
          >2024</div>
        </div>
        <div style={{ display: "inline-block" }}>
          <div className="sign-in-button-4" style={{ width: "150px", margin: "10px" }}
            onClick={() => {
              setCustomersList(Projects1.filter(a => a.meta.book_author == "2015"))

            }}
          >2015</div>
        </div>

        <div style={{ display: "inline-block" }}>
          <div className="sign-in-button-4" style={{ width: "150px", margin: "10px" }}
            onClick={() => {
              setCustomersList(Projects1)
            }}
          >All</div>
        </div>

      </div>
      <div style={{ backgroundColor: "#fff", padding: "10px", width: "97%", margin: "10px" }}>
        <DataTable
          columns={columns}
          data={CustomersList}
          defaultSortFieldId={1}
          defaultSortAsc={false}
          striped
          // sortIcon={<SortIcon />}
          pagination
          selectableRows
        />
      </div>
      {Reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }
    </div>
  )
}